exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = 89
// module chunks = 220